export const liveViewH5 =
{
    path: "/liveViewH5",
    component: () => import("@/views/liveViewH5/indexH5"),
    meta: {
        hidden: false,
    },
}